<template>
  <div style="width: 100%">
    <v-card
      v-if="relatorio"
      flat
      class="pa-2"
    >
      <!-- Atividades de Interesse -->
      <v-row>
        <v-col cols="12">
          <app-title texto="ATIVIDADES DE INTERESSE" />
        </v-col>
      </v-row>

      <!-- Áreas de Cultura e Arte -->
      <v-row>
        <!-- Gráficos-->
        <v-col cols="12">
          <app-title texto="ÁREAS DE CULTURA E ARTE" cor="secondary" />
        </v-col>
        <v-col cols="12">
          <bar-chart
            :categorias="dadosBarChartArteCultura.categorias"
            :dados="dadosBarChartArteCultura.dados"
            :fonte="`Fonte: Sistema Desenvolva, ${ano}`"
            :tooltip="tooltipBarChart"
            class="chart"
            descricao-eixo-y="Quantidade"
            titulo="Comparativo de Interesses<br>Atividades de Cultura e Arte"
            :is-get-svg="isGetSvg.cultura.bar"
            @svg="(value) => svg.cultura.bar = value"
          />
        </v-col>

        <!-- Resultados -->
        <v-col cols="12">
          <app-title texto="RESULTADOS: ÁREAS DE CULTURA E ARTE" cor="secondary" />
        </v-col>
        <v-col cols="12">
          <tabela-resultado-area
            :relatorio="relatorio"
            titulo="Cultura e Arte"
            area-attr="areasCultura"
          />
        </v-col>
      </v-row>

      <!-- Instrutor de Cultura e Arte -->
      <v-row>
        <!-- Gráficos-->
        <v-col cols="12">
          <app-title texto="INSTRUTOR DE CULTURA E ARTE" cor="secondary" />
        </v-col>
        <v-col cols="12">
          <pie-chart
            titulo="Comparativo de Interesses<br>Instrutor de Cultura e Arte"
            :fonte="`Fonte: Sistema Desenvolva, ${ano}`"
            :dados="dadosPieChartArteCultura.series"
            :dados-complementares="dadosPieChartArteCultura.subSeries"
            class="chart"
            :is-get-svg="isGetSvg.cultura.pie"
            @svg="(value) => svg.cultura.pie = value"
          />
        </v-col>

        <!-- Resultados -->
        <v-col cols="12">
          <app-title texto="RESULTADOS: INSTRUTOR DE CULTURA E ARTE" cor="secondary" />
        </v-col>
        <v-col cols="12">
          <tabela-resultado-instrutor
            :relatorio="relatorio"
            titulo="Cultura e Arte"
            icone="palette"
            quantidade-instrutor-attr="quantidadeInstrutorCultura"
            quantidade-nao-instrutor-attr="quantidadeNaoInstrutorCultura"
            quantidade-nao-respondeu-instrutor-attr="quantidadeNaoRespondeuInstrutorCultura"
            cursos-attr="cursosCultura"
            quantidade-cursos-attr="quantidadeCursosCultura"
          />
        </v-col>
      </v-row>

      <!-- Áreas de Esporte -->
      <v-row>
        <!-- Gráficos -->
        <v-col cols="12">
          <app-title texto="ÁREAS DE ESPORTE" cor="secondary" />
        </v-col>
        <v-col cols="12">
          <bar-chart
            :categorias="dadosBarChartEsporte.categorias"
            :dados="dadosBarChartEsporte.dados"
            :fonte="`Fonte: Sistema Desenvolva, ${ano}`"
            :tooltip="tooltipBarChart"
            class="chart"
            descricao-eixo-y="Quantidade"
            titulo="Comparativo de Interesses<br>Atividades de Esporte"
            :is-get-svg="isGetSvg.esporte.bar"
            @svg="(value) => svg.esporte.bar = value"
          />
        </v-col>

        <!-- Resultados -->
        <v-col cols="12">
          <app-title texto="RESULTADOS: ÁREAS DE ESPORTE" cor="secondary" />
        </v-col>
        <v-col cols="12">
          <tabela-resultado-area
            :relatorio="relatorio"
            titulo="Esporte"
            area-attr="areasEsporte"
          />
        </v-col>
      </v-row>

      <!-- Instrutor de Esporte -->
      <v-row>
        <!-- Gráficos -->
        <v-col cols="12">
          <app-title texto="INSTRUTOR DE ESPORTE" cor="secondary" />
        </v-col>
        <v-col cols="12">
          <pie-chart
            titulo="Comparativo de Interesses<br>Instrutor de Esporte"
            :fonte="`Fonte: Sistema Desenvolva, ${ano}`"
            :dados="dadosPieChartEsporte.series"
            :dados-complementares="dadosPieChartEsporte.subSeries"
            class="chart"
            :is-get-svg="isGetSvg.esporte.pie"
            @svg="(value) => svg.esporte.pie = value"
          />
        </v-col>
      </v-row>

      <!-- Resultados -->
      <v-row>
        <v-col cols="12">
          <app-title texto="RESULTADOS: INSTRUTOR DE ESPORTE" cor="secondary" />
        </v-col>
        <v-col cols="12">
          <tabela-resultado-instrutor
            :relatorio="relatorio"
            titulo="Esporte"
            icone="directions_bike"
            quantidade-instrutor-attr="quantidadeInstrutorEsporte"
            quantidade-nao-instrutor-attr="quantidadeNaoInstrutorEsporte"
            quantidade-nao-respondeu-instrutor-attr="quantidadeNaoRespondeuInstrutorEsporte"
            cursos-attr="cursosEsporte"
            quantidade-cursos-attr="quantidadeCursosEsporte"
          />
        </v-col>
      </v-row>

      <!-- Relatório PDF -->
      <v-row
        class="justify-end mb-1"
      >
        <v-tooltip
          max-width="400"
          top
        >
          <template v-slot:activator="{ on }">
            <v-btn
              color="success"
              @click="getRelatorio()"
              v-on="on"
            >
              <v-icon>get_app</v-icon>
              BAIXAR PDF
            </v-btn>
          </template>
          <span>Clique para baixar o relatório dos dados em formato PDF.</span>
        </v-tooltip>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { sum } from 'mathjs';
import AppTitle from '@/components/core/AppTitle';
import BarChart from '@/components/chart/BarChart';
import PieChart from '@/components/chart/PieChart';
import { generatePDF, preparePdf, convertSvg } from '@/modules/relatorioPDF';
import TabelaResultadoArea from './TabelaResultadoInteresseArea';
import TabelaResultadoInstrutor from './TabelaResultadoGeralInteresseInstrutor';

export default {
  name: 'RelatorioPerfilGeralInteresse',

  components: {
    AppTitle,
    BarChart,
    PieChart,
    TabelaResultadoArea,
    TabelaResultadoInstrutor,
  },

  props: {
    relatorio: {
      type: Object,
      required: true,
    },
    ano: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      tooltipBarChart: {
        headerFormat: '<span style="padding:2px;"><b>{point.key}</b></span><table>',
        pointFormat:
          '<tr>'
          + '<td style="color:{series.color};padding:0">Quantidade: </td>'
          + '<td style="padding:2px;text-align:right"><span>{point.quantidade}</span></td>'
          + '</tr>',
        footerFormat: '</table>',
      },
      isGetSvg: {
        cultura: {
          bar: false,
          pie: false,
        },
        esporte: {
          bar: false,
          pie: false,
        },
      },
      svg: {
        cultura: {
          bar: null,
          pie: null,
        },
        esporte: {
          bar: null,
          pie: null,
        },
      },
    };
  },

  computed: {
    dadosBarChartArteCultura() {
      const dados = this.relatorio.areasCultura.map((d) => ({
        ...d,
        y: d.quantidade,
      })).sort((a, b) => {
        if (a.y < b.y) { return 1; }
        if (a.y > b.y) { return -1; }
        return 0;
      });

      return {
        dados: [{
          name: 'Atividade',
          data: dados,
          color: '#2D5269',
        }],
        categorias: dados.map((d) => d.nome),
      };
    },
    dadosPieChartArteCultura() {
      return {
        series: [
          {
            name: 'Respostas',
            data: [
              {
                name: 'Sim',
                y: this.relatorio.quantidadeInstrutorCultura,
                drilldown: this.relatorio.quantidadeInstrutorCultura > 0 ? 'sim' : null,
              },
              {
                name: 'Não',
                y: this.relatorio.quantidadeNaoInstrutorCultura,
              },
              {
                name: 'Não respondeu',
                y: this.relatorio.quantidadeNaoRespondeuInstrutorCultura,
                color: 'grey',
              },
            ],
          },
        ],
        subSeries: [
          {
            name: 'Sim',
            id: 'sim',
            data: this.relatorio.unidades.filter((u) => (u.quantidadeInstrutorCultura > 0))
              .map((u) => ([u.sigla, u.quantidadeInstrutorCultura])),
          },
        ],
      };
    },
    dadosBarChartEsporte() {
      const dados = this.relatorio.areasEsporte.map((d) => ({
        ...d,
        y: d.quantidade,
      })).sort((a, b) => {
        if (a.y < b.y) { return 1; }
        if (a.y > b.y) { return -1; }
        return 0;
      });

      return {
        dados: [{
          name: 'Atividade',
          data: dados,
          color: '#2D5269',
        }],
        categorias: dados.map((a) => a.nome),
      };
    },
    dadosPieChartEsporte() {
      return {
        series: [
          {
            name: 'Respostas',
            data: [
              {
                name: 'Sim',
                y: this.relatorio.quantidadeInstrutorEsporte,
                drilldown: this.relatorio.quantidadeInstrutorEsporte > 0 ? 'sim' : null,
              },
              {
                name: 'Não',
                y: this.relatorio.quantidadeNaoInstrutorEsporte,
              },
              {
                name: 'Não respondeu',
                y: this.relatorio.quantidadeNaoRespondeuInstrutorEsporte,
                color: 'grey',
              },
            ],
          },
        ],
        subSeries: [
          {
            name: 'Sim',
            id: 'sim',
            data: this.relatorio.unidades.filter((u) => (u.quantidadeInstrutorEsporte > 0))
              .map((u) => ([u.sigla, u.quantidadeInstrutorEsporte])),
          },
        ],
      };
    },
  },

  methods: {
    async getRelatorio() {
      this.isGetSvg.cultura.bar = true;
      this.isGetSvg.cultura.pie = true;
      this.isGetSvg.esporte.bar = true;
      this.isGetSvg.esporte.pie = true;
      await preparePdf(async () => {
        const documento = {
          nome: 'relatorio-geral-interesse-perfil',
          orientacao: 'landscape',
          cabecalho: {
            titulo: 'Relatório Geral das Atividades de Interesse',
            itens: [
              `Unidade(s): ${this.relatorio.unidades.map((u) => u.sigla).join(', ')}`,
            ],
          },
          blocos: [
            { titulo: 'CULTURA E ARTE' },
            {
              subtitulo: 'ÁREAS DE CULTURA E ARTE',
              itens: [
                { tipo: 'imagem', valor: await convertSvg(this.svg.cultura.bar) },
              ],
            },
            {
              subtitulo: 'RESULTADOS: ÁREAS DE CULTURA E ARTE',
              itens: [{
                tipo: 'tabela',
                valor: {
                  colunas: [
                    'ÁREA DE CULTURA E ARTE',
                    'QUANTIDADE',
                  ],
                  linhas: this.relatorio.areasCultura.map((a) => ([
                    a.nome,
                    a.quantidade,
                  ])),
                  rodape: [
                    'TOTAL',
                    sum(
                      this.relatorio.areasCultura.length > 0 ? this.relatorio.areasCultura.map((a) => a.quantidade) : 0,
                    ),
                  ],
                },
              }],
            },
            {
              subtitulo: 'INSTRUTOR DE CULTURA E ARTE',
              itens: [
                { tipo: 'imagem', valor: await convertSvg(this.svg.cultura.pie) },
              ],
            },
            {
              subtitulo: 'RESULTADOS: INSTRUTOR DE CULTURA E ARTE',
              itens: [{
                tipo: 'tabela',
                valor: {
                  colunas: [
                    'UNIDADE',
                    'INTERESSADOS',
                    'NÃO\nINTERESSADOS',
                    'NÃO\nRESPONDEU',
                    'TOTAL DE\nSERVIDORES',
                    'CURSOS\nCADASTRADOS',
                  ],
                  linhas: this.relatorio.unidades.map((u) => ([
                    `${u.nome} (${u.sigla})`,
                    u.quantidadeInstrutorCultura,
                    u.quantidadeNaoInstrutorCultura,
                    u.quantidadeNaoRespondeuInstrutorCultura,
                    u.quantidadePerfis,
                    u.cursosCultura.length,
                  ])),
                  rodape: [
                    'TOTAL',
                    this.relatorio.quantidadeInstrutorCultura,
                    this.relatorio.quantidadeNaoInstrutorCultura,
                    this.relatorio.quantidadeNaoRespondeuInstrutorCultura,
                    this.relatorio.quantidadePerfis,
                    this.relatorio.quantidadeCursosCultura,
                  ],
                },
              }],
            },
            { titulo: 'ESPORTE' },
            {
              subtitulo: 'ÁREAS DE ESPORTE',
              itens: [
                { tipo: 'imagem', valor: await convertSvg(this.svg.esporte.bar) },
              ],
            },
            {
              titulo: '',
              subtitulo: 'RESULTADOS: ÁREAS DE ESPORTE',
              itens: [{
                tipo: 'tabela',
                valor: {
                  colunas: [
                    'ÁREA DE ESPORTE',
                    'QUANTIDADE',
                  ],
                  linhas: this.relatorio.areasEsporte.map((a) => ([
                    a.nome,
                    a.quantidade,
                  ])),
                  rodape: [
                    'TOTAL',
                    sum(
                      this.relatorio.areasEsporte.length > 0 ? this.relatorio.areasEsporte.map((a) => a.quantidade) : 0,
                    ),
                  ],
                },
              }],
            },
            {
              subtitulo: 'INSTRUTOR DE ESPORTE',
              itens: [
                { tipo: 'imagem', valor: await convertSvg(this.svg.esporte.pie) },
              ],
            },
            {
              subtitulo: 'RESULTADOS: INSTRUTOR DE ESPORTE',
              itens: [{
                tipo: 'tabela',
                valor: {
                  colunas: [
                    'UNIDADE',
                    'INTERESSADOS',
                    'NÃO\nINTERESSADOS',
                    'NÃO\nRESPONDEU',
                    'TOTAL DE\nSERVIDORES',
                    'CURSOS\nCADASTRADOS',
                  ],
                  linhas: this.relatorio.unidades.map((u) => ([
                    `${u.nome} (${u.sigla})`,
                    u.quantidadeInstrutorEsporte,
                    u.quantidadeNaoInstrutorEsporte,
                    u.quantidadeNaoRespondeuInstrutorEsporte,
                    u.quantidadePerfis,
                    u.cursosEsporte.length,
                  ])),
                  rodape: [
                    'TOTAL',
                    this.relatorio.quantidadeInstrutorEsporte,
                    this.relatorio.quantidadeNaoInstrutorEsporte,
                    this.relatorio.quantidadeNaoRespondeuInstrutorEsporte,
                    this.relatorio.quantidadePerfis,
                    this.relatorio.quantidadeCursosEsporte,
                  ],
                },
              }],
            },
          ],
        };
        generatePDF(documento);
      });
      this.isGetSvg.cultura.bar = false;
      this.isGetSvg.cultura.pie = false;
      this.isGetSvg.esporte.bar = false;
      this.isGetSvg.esporte.pie = false;
    },
  },
};
</script>

<style scoped>
.chart {
  width: 100%;
  max-height: 400px;
  font-family: Roboto, sans-serif;
}

.chart >>> .highcharts-legend-item rect {
  display: none;
}

.chart >>> .highcharts-legend-item {
  pointer-events: none;
}
</style>
